import { RouterProvider, createBrowserRouter, Navigate } from 'react-router-dom'
import ErrorBoundary from './components/ErrorBoundary'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'react-hot-toast'
import { ThemeProvider } from './context/ThemeContext'
import { AuthProvider } from './context/AuthContext'
import Layout from './components/layout/Layout'
import ProtectedRoute from './components/ProtectedRoute'
import Home from './pages/Home'
import Shop from './pages/Shop'
import ProductDetail from './pages/ProductDetail'
import Cart from './pages/Cart'
import Templates from './pages/Templates'
import Checkout from './pages/Checkout'
import Login from './pages/Login'
import Claim from './pages/Claim'
import { Account, Orders, OrderDetail, Wishlist, Contact, NotFound } from './pages/index'
import Settings from './pages/Settings'
import Addresses from './pages/Addresses'
import Promotions from './pages/Promotions'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 180000 },
  },
})

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true,           element: <ProtectedRoute><Home /></ProtectedRoute> },
      { path: 'login',         element: <Login /> },
      { path: 'claim/:token',  element: <Claim /> },
      { path: 'contact',       element: <ProtectedRoute><Contact /></ProtectedRoute> },
      { path: 'shop',          element: <ProtectedRoute><Shop /></ProtectedRoute> },
      { path: 'product/:id',   element: <ProtectedRoute><ProductDetail /></ProtectedRoute> },
      { path: 'cart',          element: <ProtectedRoute><Cart /></ProtectedRoute> },
      { path: 'checkout',      element: <ProtectedRoute><Checkout /></ProtectedRoute> },
      { path: 'account',       element: <ProtectedRoute><Account /></ProtectedRoute> },
      { path: 'orders',        element: <ProtectedRoute><Orders /></ProtectedRoute> },
      { path: 'templates',      element: <ProtectedRoute><Templates /></ProtectedRoute> },
      { path: 'orders/:id',    element: <ProtectedRoute><OrderDetail /></ProtectedRoute> },
      { path: 'wishlist',      element: <ProtectedRoute><Wishlist /></ProtectedRoute> },
      { path: 'account/settings',   element: <ProtectedRoute><Settings /></ProtectedRoute> },
      { path: 'account/addresses',  element: <ProtectedRoute><Addresses /></ProtectedRoute> },
      { path: 'promotions',         element: <ProtectedRoute><Promotions /></ProtectedRoute> },
      { path: 'shop-top-filter', element: <Navigate to="/shop" replace /> },
      { path: 'shop-category', element: <Navigate to="/shop" replace /> },
      { path: '*',             element: <NotFound /> },
    ],
  },
])

export default function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <AuthProvider>
            <RouterProvider router={router} />
            <Toaster
              position="top-right"
              toastOptions={{
                duration: 3000,
                style: {
                  fontFamily: '"Public Sans", sans-serif',
                  fontSize: '14px',
                  borderRadius: '10px',
                  padding: '12px 16px',
                },
                success: { iconTheme: { primary: '#0e947a', secondary: 'white' } },
              }}
            />
          </AuthProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  )
}
